/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:47
 * @LastEditTime: 2021-07-16 17:33:47
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\newspaper\newspaperRouter.js
 * @Description: 
 */
'use strict';
angular.module('editingCenterNewspaperRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.editctr.newspaper', {
                url: '/newspaper',
            })
            .state('front.editctr.newspaper.myshare', {
                // 稿件分享管理
                url: '/myshare?siteid&mediatype',
                views: {
                    'main@front.editctr': {
                        templateUrl: './editingCenter/iWo/myManuscript/myShare/myShare_tpl.html',
                        controller: 'myShareCtrl',
                    },
                },
            });
    },
]);
